import { render, staticRenderFns } from "./GvdSectionSelect.vue?vue&type=template&id=05d2e296&scoped=true"
import script from "./GvdSectionSelect.vue?vue&type=script&lang=ts"
export * from "./GvdSectionSelect.vue?vue&type=script&lang=ts"
import style0 from "./GvdSectionSelect.vue?vue&type=style&index=0&id=05d2e296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d2e296",
  null
  
)

export default component.exports